import { DialogTrigger, Dialog, Modal } from 'react-aria-components';
import { useForm, SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { createTemplate } from '@/api/createTemplate';
import { updateTemplate } from '@/api/updateTemplate';
import Button from '@/components/Button/Button';
import InputText from '@/components/InputText/InputText';
import SelectField from '@/components/SelectField/SelectField';
import { Template, CreateTemplateRequest } from '@/types/template';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  afterSubmit: () => void;
  template?: Template;
};

const categories = ['支援記録', '支援計画', '連絡帳', '支援目標', '支援内容', '体調メモ'];

export const CreateOrEditTemplateDialog = ({ isOpen, setIsOpen, afterSubmit, template }: Props) => {
  const isEdit = template !== undefined;

  const schema: yup.ObjectSchema<CreateTemplateRequest> = yup
    .object({
      body: yup.string().required('定型文は必須です'),
      category: yup.string().required('カテゴリは必須です'),
    })
    .required();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<CreateTemplateRequest>({
    resolver: yupResolver(schema),
    defaultValues: {
      body: template ? template.body : '',
      category: template ? template.category : '',
    },
  });

  const onSubmit: SubmitHandler<CreateTemplateRequest> = async (data) => {
    if (!isEdit) {
      try {
        console.log(data);
        const result = await createTemplate({
          body: data.body,
          category: data.category,
        });
        console.log(result);
        if (result.status === 201) {
          console.log(result.result);
          toast.success('定型文マスタを登録しました');
        } else {
          console.log('error');
          toast.error('定型文マスタの登録に失敗しました');
        }
      } catch (error) {
        console.log('error');
        toast.error('定型文マスタの登録に失敗しました');
      }
    } else {
      try {
        const result = await updateTemplate(template!.id, {
          id: template!.id,
          body: data.body,
          category: data.category,
        });
        if (result.status === 200) {
          toast.success('定型文マスタを更新しました');
        } else {
          toast.error('定型文マスタの更新に失敗しました');
        }
      } catch (error) {
        toast.error('定型文マスタの更新に失敗しました');
      }
    }

    setIsOpen(false);
    afterSubmit();
  };

  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={() => setIsOpen(false)}
    >
      <Modal className="fixed inset-0 z-50 flex h-full w-full items-center justify-center bg-black/50">
        <Dialog className="w-[900px] rounded-lg border border-gray-400 bg-white p-6 shadow-lg outline-none">
          <div className="flex flex-row justify-between">
            <h1 className="mb-5 text-2xl font-700">定型文マスタ登録</h1>
          </div>

          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-full p-10"
          >
            <div className="flex justify-between space-x-2 p-4">
              <SelectField
                name="category"
                label="カテゴリ"
                control={control}
                items={categories.map((type) => ({
                  label: type,
                  value: type,
                }))}
                required={true}
              />
            </div>
            <div className="flex justify-between space-x-2 p-4">
              <InputText
                label="定型文"
                type="text"
                required={true}
                {...register('body')}
              />
            </div>
            <div className="mt-10 flex flex-row items-center justify-center space-x-2">
              <Button
                type="submit"
                size="lg"
                variant="outline"
                onClick={() => setIsOpen(false)}
              >
                戻る
              </Button>
              <Button
                type="submit"
                size="lg"
                variant={Object.keys(errors).length > 0 ? 'disabled' : 'solid-fill'}
                disabled={Object.keys(errors).length > 0}
              >
                {isEdit ? '保存' : '登録'}
              </Button>
            </div>
          </form>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
};
